import CreateAccommodation from './CreateAccommodation';

export default CreateAccommodation;
